import { render, staticRenderFns } from "./VendorList.vue?vue&type=template&id=aec2aabc&lang=pug"
import script from "./VendorList.vue?vue&type=script&lang=ts"
export * from "./VendorList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports